/**
 * Icon — porta única de ícone do app.
 *
 * Resolve pela CHAVE DE USO do handoff (assets/icons/icons.json), não pelo
 * nome do ícone: `<Icon name="action.back" />`, não `<ChevronLeft />`. Assim,
 * trocar o desenho de uma ação é mexer no JSON e rodar `npm run icons`, sem
 * caçar import por import.
 *
 * Tamanhos previstos (01-fundamentos): 14 dentro de badge e macro, 16-18
 * inline em botão e lista, 20 em botão redondo de 40, 24 em nav e ações de post.
 *
 * Traço: 2 é o padrão; 1.8 nas ações de post; 2.4 em chevron e check pequenos.
 *
 * Acessibilidade: sem `title` o ícone é decorativo e sai da árvore de
 * acessibilidade. Com `title`, vira imagem com nome — use quando o ícone é a
 * única informação (botão só de ícone).
 */

import React from 'react';
import ICONES from './mapa';

const TRACO = {
  padrao: 'var(--lv-icon-stroke)',
  leve: 'var(--lv-icon-stroke-light)',
  forte: 'var(--lv-icon-stroke-bold)',
};

export default function Icon({
  name,
  size = 20,
  color = 'currentColor',
  strokeWidth,
  weight,
  title,
  className,
  ...rest
}) {
  const Componente = ICONES[name];

  if (!Componente) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(
        `[Icon] chave desconhecida: "${name}". ` +
          'As chaves válidas vêm de handoff/assets/icons/icons.json.'
      );
    }
    return null;
  }

  // weight é o atalho semântico; strokeWidth crua ainda funciona.
  const traco = strokeWidth ?? (weight ? TRACO[weight] : undefined);

  return (
    <Componente
      size={size}
      color={color}
      {...(traco !== undefined ? { strokeWidth: traco } : null)}
      className={className}
      {...(title
        ? { role: 'img', 'aria-label': title }
        : { 'aria-hidden': true, focusable: 'false' })}
      {...rest}
    />
  );
}

/** Lista de chaves válidas — usada pelo catálogo de dev. */
export const CHAVES = Object.keys(ICONES);
